import { useSyncExternalStore } from "react";
// // ===================================================================================
// // ========================== Host Selector for selecting shared states ==============
// // ===================================================================================
export const useHostSelector = (selector) => {
    const bridge = globalThis.__HOST_BRIDGE_INSTANCE__;

    if (!bridge) {
        throw new Error("HostBridge not available");
    }

    return useSyncExternalStore(
        (listener) => bridge.subscribe(listener),
        () => selector(bridge.getRootState()),
        () => selector(bridge.getRootState()),
    );
};
